import React from "react";

import { JOKI } from "../../JOKI";
//import useCurrentUser from "../../services/User/UserHooks";

import { Header, Icon } from "selfly-ui-react";

import ConfirmButton from "../../components/ConfirmButton/ConfirmButton";
import Notifications from "../../components/Notification/Notifications";
import SessionCountdown from "../../components/SessionCountdown/SessionCountdown";

import OrganizationDropdown from './OrganizationDropdown';
import { version } from '../../../package.json';

//TODO: Rework this component so that is does not constantly re-render itself.
export default function SeedsHeaderWithNotifications(props) {
    const user = props.user;

    function logout() {
        JOKI.trigger({
            to: "AuthenticationService",
            key: "logout",
        });
    }

    return (
        <header className="se-header se-header--blue">
            <div className="se-header-content">
                <div className="se-header-title">
                    <img
                        alt="logotype"
                        src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
                        className="se-logo selfly-logo"
                    ></img>
                    <h1 className="se-header-title-heading">{`Selfly Admin Portal ${version}`}</h1>
                </div>
                <div className="header-information">
                    <SessionCountdown />
                    <Notifications />
                    <OrganizationDropdown user={user} />
                    <UserName user={user} />
                    <ConfirmButton
                        id="ButtonLogout"
                        title="Logging out?"
                        labelOk="Logout"
                        labelCancel="Cancel"
                        modalContent={`User '${
                            user !== null ? user.fullName : "unknown"
                        }' is currently logged in. Press 'Logout' to proceed with logout.`}
                        onClick={logout}
                    >
                        Logout
                    </ConfirmButton>
                </div>
                </div>
                </header>
    );
}

const UserName = React.memo(
    props => {
        if (props.user === undefined || props.user === null || props.user.fullName === undefined) {
            return null;
        }

        return (
            <span className="user-name">
                <Icon>person</Icon> {props.user.fullName}
            </span>
        );
    },
    (prev, next) => {
        if (prev.user === null || next.user === null || prev.user.fullName === undefined || next.user.fullName) {
            return false;
        }

        return prev.user.fullName === next.user.fullName;
    }
);
